import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Input,
  InputAdornment,
  Paper,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

// Icons
import { Label, Search as SearchIcon } from "@material-ui/icons";
import config from "../../config";
import Widget from "../../components/Widget/Widget";
import useStyles from "./styles";
import {
  CurrencyState,
  getCurrencyDatas,
  updateCurrencyData,
} from "../../context/CurrenyConverterContext";
import alertify from "alertifyjs";

const CurrencyConvert = () => {
  const classes = useStyles();
  const context = CurrencyState();

  const [currencyData, setCurrencyData] = useState(null);

  const handleChange = (event, item) => {
    const { value } = event.target;
    const temp = currencyData.map((element, index) => {
      if (item.id == element.id) {
        return {
          ...element,
          price: value,
        };
      } else return element;
    });
    setCurrencyData(temp);
  };

  useEffect(() => {
    getCurrencyDatas(context.setCurrnecyData);
  }, []);

  useEffect(() => {
    setCurrencyData(context.currencyData.currencyData);
  }, [context.currencyData.isLoaded]);

  const validate = () => {
    let valid = true;
    currencyData.map((item, index) => {
      if (item.price.length == 0) return (valid = false);
    });
    return valid;
  };

  const hadleUpdateData = async () => {
    if (validate()) {
      alertify.set("notifier", "position", "top-right");
      const temp = currencyData.map((item, index) => {
        return {
          id: item.id,
          price: item.price,
        };
      });
      const reqData = {
        currency: temp,
      };
      await updateCurrencyData(context.setCurrnecyData, reqData);
      await getCurrencyDatas(context.setCurrnecyData);
      alertify.success("Currency data updated");
    }
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Widget inheritHeight>
            <Grid container spacing={5}>
              <Grid item md={4} xs={4} sm={4}>
                <Box>
                  <span className={classes.mainPageTitle}>
                    <b>Currency Converter</b>
                  </span>
                </Box>
              </Grid>
            </Grid>
          </Widget>
        </Grid>
        {!context.currencyData.isLoaded ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            width={"100vw"}
            height={"calc(100vh - 200px)"}
          >
            <CircularProgress size={50} />
          </Box>
        ) : (
          currencyData &&
          currencyData.length > 0 && (
            <div className="smallTable">
              <Grid item xs={12} style={{}}>
                <Paper className={classes.root}>
                  <div className={classes.textFieldMainContainer}>
                    {currencyData &&
                      currencyData.length > 0 &&
                      currencyData.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className={classes.textFieldContainer}
                          >
                            <p style={{ paddingTop: "10px" }}>
                              {item.from} to {item.to} ($) ={" "}
                            </p>
                            <Box
                              display={"flex"}
                              flexDirection={"column"}
                              marginLeft={"10px"}
                              width={"80%"}
                            >
                              <TextField
                                fullWidth
                                id="search-field"
                                label={item.currency_name}
                                margin="normal"
                                variant="filled"
                                onChange={(e) => handleChange(e, item)}
                                value={item.price}
                                type="number"
                                placeholder="CAD ($)"
                              />
                            </Box>
                          </div>
                        );
                      })}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginTop: "10px",
                      marginRight: "5%",
                    }}
                  >
                    <Button
                      onClick={() => hadleUpdateData()}
                      variant="contained"
                      color="primary"
                    >
                      {" "}
                      Update{" "}
                    </Button>
                  </div>
                </Paper>
              </Grid>
            </div>
          )
        )}
      </Grid>
    </>
  );
};

export default withRouter(CurrencyConvert);
